import React, { useContext, useMemo } from "react";
import { UserTypeContext } from "./context/userStatus";
import { ThemeProvider as MuiV5ThemeProvider, createTheme } from "@mui/material/styles";
import { ThemeProvider as MuiV4ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import palette from "./theme/palette";
import typography from "./theme/typography";
import componentsOverride from "./theme/overrides";

const AppProvider = ({ children }: { children: React.ReactNode }) => {
    const { state: outcomeState } = useContext(UserTypeContext);

    const prefersDark =
        typeof outcomeState?.isDarkMode === "boolean"
            ? outcomeState.isDarkMode
            : window.matchMedia("(prefers-color-scheme: dark)").matches;

    const v5ThemeOptions: any = useMemo(() => {
        const effectiveDarkMode = prefersDark;
        return {
            palette: {
                ...palette,
                mode: effectiveDarkMode ? "dark" : "light",
                background: {
                    default: effectiveDarkMode ? "#1a1a1a" : "#fff",
                    paper: effectiveDarkMode ? "#2d2d2d" : "#fff",
                },
                text: {
                    primary: effectiveDarkMode ? "#eeeeee" : "#3e4240",
                    secondary: effectiveDarkMode ? "#656565" : "#656565",
                },
            },
            typography,
        };
    }, [prefersDark]);

    const v5Theme = createTheme(v5ThemeOptions);
    v5Theme.components = componentsOverride(v5Theme);

    const v4ThemeOptions: any = useMemo(() => {
        const effectiveDarkMode = prefersDark;
        return {
            palette: {
                ...palette,
                type: effectiveDarkMode ? "dark" : "light",
                background: {
                    default: effectiveDarkMode ? "#1a1a1a" : "#fff",
                    paper: effectiveDarkMode ? "#2d2d2d" : "#fff",
                },
                text: {
                    primary: effectiveDarkMode ? "#eeeeee" : "#3e4240",
                    secondary: effectiveDarkMode ? "#656565" : "#656565",
                },
            },
            typography,
        };
    }, [prefersDark]);

    const v4Theme = createMuiTheme(v4ThemeOptions);

    return (
        <MuiV4ThemeProvider theme={v4Theme}>
            <MuiV5ThemeProvider theme={v5Theme}>{children}</MuiV5ThemeProvider>
        </MuiV4ThemeProvider>
    );
};

export default AppProvider;
